/**
 * Checks if the current page is either the hat customizer or create-your-own page
 * @returns boolean indicating if current page is a customizer page
 */
export function isCustomizerPage(): boolean {
	const bodyElement = document.querySelector("body");
	if (!bodyElement) return false;

	const bodyClasses = Array.from(bodyElement.classList);
	return bodyClasses.includes("hat-customizer") || bodyClasses.includes("create-your-own");
}

/**
 * Safely gets body class list as an array
 * @returns Array of class names or empty array if body element doesn't exist
 */
export function getBodyClasses(): string[] {
	const bodyElement = document.querySelector("body");
	return bodyElement ? Array.from(bodyElement.classList) : [];
}

/**
 * Checks if specifically on the hat customizer page
 * @returns boolean indicating if current page is the hat customizer
 */
export function isHatCustomizerPage(): boolean {
	return getBodyClasses().includes("hat-customizer");
}

/**
 * Checks if specifically on the create-your-own page
 * @returns boolean indicating if current page is the create-your-own page
 */
export function isCreateYourOwnPage(): boolean {
	return getBodyClasses().includes("create-your-own");
}
